import { Keuzehulp } from '../keuzehulpen'

const cvrm: Keuzehulp = {
  title: 'CVRM',
  basePath: '/cvrm',
  documentTitle: 'CVRM',
  routes: [
    {
      path: '',
      routeId: 'P14-001',
      nextRouteId: 'P14-002',
      type: 'intro',
      title: 'Voordat je begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/hoe-maak-je-jouw-risico-op-ziekte-van-hart-en-bloedvaten-kleiner',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die je nodig hebt om de keuzehulp in te vullen',
        },
        {
          title: '20 minuten',
          description: 'Zo lang zijn de meeste mensen bezig met deze keuzehulp',
        },
        {
          title: 'Zoek een rustige plek',
          description: 'Zodat je goed jouw aandacht erbij kunt houden',
        },
        {
          title: 'Bekijk je antwoorden',
          description:
            'Je antwoorden worden niet bewaard. De keuzehulp onthoudt niet waar je gebleven bent',
        },
      ],
    },
    {
      path: '/stap-1',
      routeIndex: '1',
      routeId: 'P14-002',
      nextRouteId: 'P14-003',
      type: 'chapter',
      title: 'Ziektes van hart en bloedvaten',
      subtitle: 'Stap 1',
      description: `
        <p>Wat is een ziekte van hart en bloedvaten? En waardoor kun je die krijgen?</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/cvrm-stap-1.jpg`,
        alt: '',
      },
      button: 'Start de keuzehulp',
    },
    {
      path: '/stap-1/wat-is-een-ziekte-van-hart-en-bloedvaten',
      routeId: 'P14-003',
      nextRouteId: 'P14-004',
      type: 'explanation',
      title: 'Wat is een ziekte van hart en bloedvaten?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Bij een ziekte van je hart en bloedvaten gaan bloedvaten een beetje dichtzitten. Hierdoor stroomt er minder bloed doorheen en krijgen de organen minder zuurstof. Dit kan ervoor zorgen dat organen minder goed werken.</p>

          <p>Soms ontstaat er een bloedprop in een bloedvat. Dan kan er helemaal geen bloed meer doorheen stromen. Hierdoor kan het orgaan kapotgaan.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/welke-problemen-kun-je-krijgen',
      routeId: 'P14-004',
      nextRouteId: 'P14-005',
      type: 'explanation',
      title: 'Welke problemen kun je krijgen door een ziekte van hart en bloedvaten?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Door een ziekte van je hart en bloedvaten kun je verschillende klachten krijgen. Welke problemen je krijgt, hangt af van de plek waar je bloedvaten dichtzitten of zwak zijn.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Je hart</h2>
          <p style="margin-top: 0;">Je kunt hartkramp krijgen of een hartaanval.</br>
          Een hartaanval beschadigt je hartspier. Hierdoor kan je hart slechter gaan werken. Je wordt moe en kunt minder doen. Deze schade gaat niet meer weg.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Je hersenen</h2>
          <p style="margin-top: 0;">Je kunt een beroerte krijgen. Een beroerte beschadigt een deel van je hersenen. Deze schade gaat niet meer weg. Dat kan zorgen voor:</p>
          <ul>
            <li>een verlamde arm</li>
            <li>een verlamd been</li>
            <li>een scheve mond</li>
            <li>moeite met praten</li>
            <li>slecht zien</li>
          </ul>

          <p>Je kunt hier de rest van je leven last van hebben.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Je benen</h2>
          <p style="margin-top: 0;">Je kunt etalagebenen krijgen. Bij etalagebenen krijg je pijn in je been als je gaat lopen. Soms al na 50 of 100 meter lopen. Je moet dan steeds stoppen met lopen.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/hoe-komt-het-dat-je-risico-groter-is',
      routeId: 'P14-005',
      nextRouteId: 'P14-006',
      type: 'explanation',
      title: 'Hoe komt het dat je risico op een ziekte van hart en bloedvaten groter is?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p style="margin-bottom: 0;">Je risico op een ziekte van je hart en bloedvaten kan groter zijn door deze dingen:</p>
          <ul style="margin-top: 0;">
            <li>Je hebt een hoge bloeddruk</li>
            <li>Je hebt een hoog cholesterol.</li>
            <li>Je rookt.</li>
            <li>Meer mensen in je familie hebben al een ziekte van hun hart en bloedvaten.</li>
            <li>Je hebt diabetes type 2.</li>
            <li>Je nieren werken minder goed.</li>
            <li>Je hebt een ziekte zoals reumatoïde artritis of jicht.</li>
          </ul>

          <p>Het is belangrijk dat je dit risico kleiner maakt.</p>
        </div>
      `,
      info: [
        {
          urlText: 'Wat is een hoge bloeddruk?',
          title: 'Wat is een hoge bloeddruk?',
          content: `<div>
            <p>Als je een hoge bloeddruk hebt, is de druk in je bloedvaten te hoog. De bloeddruk meet je met een bloeddrukmeter. Je huisarts of praktijkondersteuner kan dit voor je meten. En ze kunnen je advies geven hoe je het zelf kunt meten.</p>

            <p>Er zijn 2 getallen, het hoogste getal is de bovendruk. Het laagste getal is de onderdruk. Als de bovendruk te hoog is, noemen we dat een hoge bloeddruk.</p>

            <p>Wil je nog meer weten over hoge bloeddruk? Kijk dan op Thuisarts.nl. Aan het einde van deze keuzehulp vind je de link naar deze informatie.</p>
          </div>`,
        },
        {
          urlText: 'Wat is cholesterol?',
          title: 'Wat is cholesterol?',
          content: `<div>
            <p>Cholesterol is een soort vet. Je lichaam maakt cholesterol in de lever. Ook komt er cholesterol in je lichaam via je voeding.</p>

            <p>Je hebt cholesterol nodig om cellen, hormonen en gal te maken. Maar te veel cholesterol is slecht voor je bloedvaten.</p>

            <p>Wil je nog meer weten over cholesterol? Kijk dan op Thuisarts.nl. Aan het einde van deze keuzehulp vind je de link naar deze informatie.</p>
          </div>`,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-1/hoe-kun-je-je-risico-kleiner-maken',
      routeId: 'P14-006',
      nextRouteId: 'P14-007',
      type: 'explanation',
      title: 'Hoe kun je je risico kleiner maken?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p style="margin-bottom: 0;">Hiermee kun je de kans op een ziekte van je hart en bloedvaten kleiner maken:</p>
          <ul style="margin-top: 0;">
            <li>gezond leven </br> Je gaat bijvoorbeeld meer bewegen. Of je stopt met roken.</li>
            <li>medicijnen </br> Bijvoorbeeld voor je bloeddruk of je cholesterol.</li>
          </ul>

          <p>Door gezonder te leven wordt je risico op een ziekte kleiner. Je hebt dan misschien geen medicijnen nodig. Of je kunt zelfs stoppen met sommige medicijnen.</p>

          <p>Soms zijn medicijnen wel nodig. Je arts bespreekt dit met je. Als je medicijnen nodig hebt, blijft gezonder leven heel belangrijk.</p>

          <P>Wil je meer weten over medicijnen? Kijk dan op Thuisarts.nl.</br>
          Aan het einde van deze keuzehulp vind je de link naar deze informatie.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/vraag-1',
      routeId: 'P14-007',
      nextRouteId: 'P14-008',
      hideFromOverview: true,
      type: 'quizQuestion',
      subtitle: 'Vraag',
      title: `Stel: je kiest ervoor om je manier van leven niet te veranderen. Wat gebeurt er dan met jouw risico op een ziekte van hart en bloedvaten?`,
      quizAnswers: [
        'Je risico blijft hetzelfde',
        'Je risico wordt kleiner',
        'Je risico wordt groter',
      ],
      correctQuizAnswer: 'Je risico wordt groter',
      explanation:
        'Als je ouder wordt, wordt je risico groter. Dat is voor iedereen zo. Leef je niet zo gezond? Dan wordt je risico sneller groter. Leef je gezond? Dan duurt het langer voordat je risico groter wordt.',
      button: 'Ga verder',
    },
    {
      path: '/stap-1/vraag-2',
      routeId: 'P14-008',
      nextRouteId: 'P14-009',
      type: 'question',
      hideFromOverview: true,
      descriptionAlign: 'left',
      title: 'Gezond leven om je risico op een ziekte van hart en bloedvaten kleiner te maken',
      description: `Wat kun jij doen om jouw risico kleiner te maken? We geven je hier meer informatie over. En je kunt direct een plan maken om gezonder te leven. </br> Klik hieronder aan welke onderwerpen voor jou belangrijk zijn. Wil je alles lezen, klik dan alles aan.`,
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'Roken',
              showChapter: '2',
            },
            {
              title: 'Meeroken',
              showChapter: '3',
            },
            {
              title: 'Bewegen',
              showChapter: '4',
            },
            {
              title: 'Gezond eten',
              showChapter: '5',
            },
            {
              title: 'Stress',
              showChapter: '6',
            },
            {
              title: 'Nachtwerk',
              showChapter: '7',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2',
      routeIndex: '2',
      routeId: 'P14-009',
      nextRouteId: 'P14-010',
      type: 'chapter',
      title: 'Hoe ongezond is roken?',
      subtitle: 'Stap 2',
      description: `
        <p>Roken maakt het risico op ziektes van hart en bloedvaten groter. Daarom kun je beter stoppen met roken. Je krijgt eerst een paar vragen en daarna vertellen we je hoe je kunt stoppen met roken.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/cvrm-stap-2.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-1',
      routeId: 'P14-010',
      nextRouteId: 'P14-011',
      hideFromOverview: true,
      type: 'quizQuestion',
      title:
        'Is deze zin waar of niet waar? Als je een paar sigaretten per dag rookt, is dit niet slecht voor je gezondheid.',
      quizAnswers: ['Dat is waar', 'Dat is niet waar'],
      correctQuizAnswer: 'Dat is niet waar',
      explanation:
        'Als je rookt, heb je altijd een groot risico op een ziekte van je hart en bloedvaten. Ook als je een paar sigaretten per dag rookt. Hoe meer je rookt, hoe groter dit risico wordt. Als je lang rookt, heb je een groot risico dat je korter leeft.',
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-2',
      routeId: 'P14-011',
      nextRouteId: 'P14-012',
      hideFromOverview: true,
      type: 'quizQuestion',
      title: 'Stoppen met roken maakt je gezondheid altijd beter. Ook als je al heel lang rookt.',
      quizAnswers: ['Dat is waar', 'Dat is niet waar'],
      correctQuizAnswer: 'Dat is waar',
      explanation: `Stoppen met roken helpt altijd! Ook als je al heel lang rookt.
        Hoe langer je gestopt bent met roken, hoe kleiner het risico op ziektes wordt. Als je 6 maanden gestopt bent met roken, heb je al minder risico op ziektes door roken.
        Stel: je bent 10 jaar gestopt met roken. Dan is je risico op een ziekte van hart en bloedvaten bijna zo laag als van iemand die nooit gerookt heeft.`,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/stoppen-met-roken',
      routeId: 'P14-012',
      nextRouteId: 'P14-013',
      type: 'explanation',
      title: 'Stoppen met roken',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je weet nu dat stoppen met roken je risico op ziektes kleiner maakt.</p>

          <p>Wil je meer weten over hoe je kunt stoppen met roken?</p>
        </div>
      `,
      button: 'Ga verder',
      videos: [
        {
          src: 'https://media.thuisarts.nl/stoppen-met-roken.mp4',
          soundSrc: 'https://media.thuisarts.nl/stoppen-met-roken.mp3',
          poster: 'https://media.thuisarts.nl/stoppen-met-roken.jpg',
          videoSize: '30mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/stoppen-met-roken.vt',
              subtitleSize: '4kb',
            },
          ],
        },
      ],
    },
    {
      path: '/stap-2/vraag-3',
      routeId: 'P14-013',
      nextRouteId: 'P14-014',
      title: 'Wil je stoppen met roken?',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Nee',
          feedback: `<p>Je wilt niet stoppen met roken. Misschien is dat omdat je al een keer hebt geprobeerd te stoppen en dit niet is gelukt. Of je hebt veel stress en je denkt dat het niet gaat lukken. Of je denkt dat het voor jou geen zin heeft om te stoppen.</p>

            <p>Je hebt gezien dat stoppen met roken veel beter is voor je gezondheid. Praat er nog eens met iemand over. Bijvoorbeeld met iemand in je familie of een vriend of vriendin. Misschien kunnen zij je helpen.</p>

            <p>Lukt het toch niet nu? Plan dan een datum om er nog eens over na te denken.</p>

            <p>Aan het einde van deze keuzehulp vind je nog meer informatie over stoppen met roken.</p>
          `,
        },
        {
          title: 'Ja, maar niet nu',
          feedback: `<p>Goed dat je nadenkt over stoppen met roken.</p>

            <p>Het is beter voor je gezondheid. Maar stoppen met roken heeft ook nog andere voordelen, bijvoorbeeld:</p>
            <ul>
              <li>Je wordt fitter en je hebt meer energie.</li>
              <li>Je ruikt niet meer naar rook.</li>
              <li>Je kunt beter proeven en ruiken.</li>
              <li>Je rokers-hoest verdwijnt.</li>
              <li>Je bent minder vaak verkouden.</li>
            </ul>
            <p>Bedenk wanneer je wel wilt stoppen met roken. Of wanneer je er weer over wilt nadenken. Praat er met iemand over. Bijvoorbeeld met iemand in je familie of een vriend of vriendin. Je kunt er ook met je arts of praktijkondersteuner over praten. Misschien kunnen zij je helpen.</p>
          `,
        },
        {
          title: 'Ja, ik ga stoppen',
          feedback: `<p>Wat goed dat je gaat stoppen met roken!</br>
            Neem ongeveer 2 weken de tijd om je goed voor te bereiden op het moment dat je stopt:</p>

            <ul>
              <li>Maak een afspraak met je huisarts of praktijkondersteuner.</li>
              <li>Maak een lijstje met voordelen. Schrijf op wat voor jou de belangrijkste voordelen zijn van stoppen.</li>
              <li>Bedenk wat je op moeilijke momenten kunt doen zodat je niet gaat roken. Zoals wandelen, een boek lezen of iemand bellen.</li>
              <li>Kies een stopdatum. Bijvoorbeeld wanneer je het niet te druk hebt en ook genoeg leuke dingen te doen hebt.</li>
              <li>Stop in 1 keer. Dat lukt beter dan langzaam minder sigaretten roken.</li>
              <li>Doe alle sigaretten weg.</li>
              <li>Vraag steun aan je partner, huisgenoten, vrienden en collega’s.</li>
              <li>Beslis of je kauwgom, tabletten of pleisters met nicotine of medicijnen wilt gebruiken.</li>
              <li>Je kunt een afspraak maken met je huisarts of praktijkondersteuner. Zij kunnen je helpen om te stoppen met roken. Met hulp lukt het meestal beter om te stoppen. En niet opnieuw te beginnen met roken.</li>
            </ul>
          `,
        },
      ],
      description: `
        <p>Je gezondheid wordt beter als je stopt met roken. Je hebt een kleinere kans op een ziekte van hart en bloedvaten. En je leeft langer. Het is dus altijd beter om te stoppen, of je nu weinig of juist veel rookt.</p>
      `,
      descriptionAlign: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-4',
      routeId: 'P14-014',
      nextRouteId: 'P14-015',
      type: 'question',
      title: 'Maak nu een plan',
      descriptionAlign: 'left',
      description: `<p>Schrijf hieronder op wat je gaat doen. Bijvoorbeeld:</p>
        <ul>
          <li>Met wie ga je praten over stoppen met roken?</li>
          <li>Ga je stoppen met roken? Wanneer?</li>
          <li>Als je niet nu gaat stoppen: wanneer ga je er weer over nadenken?</li>
        </ul>
      `,
      button: 'Volgende',
      questions: [
        {
          placeholder: 'Typ hier wat je gaat doen',
          title: 'Mijn plan',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-3',
      routeIndex: '3',
      routeId: 'P14-015',
      nextRouteId: 'P14-016',
      type: 'chapter',
      title: 'Hoe ongezond is meeroken?',
      subtitle: 'Stap 3',
      description: `<p>Misschien rook je zelf niet. Maar roken mensen om je heen wel. Wat betekent dat voor jouw gezondheid?</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/cvrm-stap-3.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-1',
      routeId: 'P14-016',
      nextRouteId: 'P14-017',
      title: 'Roken andere mensen bij je in de buurt? Bijvoorbeeld iemand met wie je samenwoont?',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback:
            'Als je vaak sigarettenrook inademt, heb je een groter risico op een ziekte van hart en bloedvaten. Zorg dus dat je geen rook van anderen inademt. Vraag je partner of huisgenoot om te stoppen met roken. Of vraag collega’s of vrienden om niet bij jou in de buurt te roken.',
        },
        {
          title: 'Nee',
          feedback:
            'Je ademt dus niet vaak sigarettenrook in. Dat is heel fijn. Het inademen van rook is namelijk slecht voor je gezondheid.',
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4',
      routeIndex: '4',
      routeId: 'P14-017',
      nextRouteId: 'P14-018',
      type: 'chapter',
      title: 'Genoeg bewegen',
      subtitle: 'Stap 4',
      description: `<p>Bewegen is goed voor je gezondheid. Je voelt je fitter en hebt meer energie. Als je genoeg beweegt heb je ook een kleinere kans om een ziekte van hart en bloedvaten te krijgen.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/cvrm-stap-4.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/wat-is-genoeg-bewegen',
      routeId: 'P14-018',
      nextRouteId: 'P14-019',
      type: 'explanation',
      title: 'Wat is genoeg bewegen?',
      align: 'left',
      titleAlign: 'center',
      description: `
          <div>
            <p>Beweeg elke week 2,5 uur, naast je gewone activiteiten. Dat maakt het risico op een ziekte van hart en bloedvaten kleiner. Je kunt bijvoorbeeld 5 keer per week een half uur bewegen.</p>

            <p>Sporten is goed, stevig wandelen ook. En je kunt bijvoorbeeld ook fietsen, zwemmen of dansen. Je hart moet wel wat sneller gaan kloppen en je moet wat sneller gaan ademen. Meer dan 2,5 uur per week bewegen is natuurlijk nog beter!</p>
          </div>
        `,
      button: 'Ga verder',
    },
    {
      path: '/stap-4/tips-om-meer-te-bewegen',
      routeId: 'P14-019',
      nextRouteId: 'P14-020',
      type: 'popupCards',
      title: 'Tips om meer te bewegen',
      align: 'left',
      description: `
        <div>
          <p>Bekijk de tips die passen bij hoe vaak jij beweegt:</p>
        </div>
        `,
      cards: [
        {
          cardTitle: 'Ik beweeg weinig of niet',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/cvrm-stap-4_3_1-card.jpg`,
            alt: '',
          },
          modalContent: `
              <div>
                <p style="margin-bottom: 0;">Meer bewegen is beter voor je gezondheid. Deze tips helpen om meer te bewegen:</p>
                <ul style="margin-top: 0;">
                  <li>Begin rustig.</li>
                  <li>Ga iets doen waarbij je wat sneller gaat ademen. En waarbij je hart sneller gaat kloppen. Zodra je stopt met bewegen, moet je wel weer normaal kunnen praten.</li>
                  <li>Ga daarna langzaam steeds iets meer doen. Begin bijvoorbeeld met een wandeling van 10 minuten. Wandel de dagen daarna wat vaker en langer. De eerste paar keer krijgt je misschien wat spierpijn. Dat is niet erg. Je zult merken dat het elke week beter gaat.</li>
                  <li>Probeer minder lang achter elkaar te zitten. Sta elk half uur even op om rond te lopen.</li>
                  <li>Kies een activiteit of sport die je leuk vindt.</li>
                  <li>Spreek met andere mensen af om samen te gaan bewegen</li>
                </ul>

                <p>Maak van bewegen een gewoonte. Probeer door de hele dag meer te bewegen. Door bijvoorbeeld in de tuin te werken, zelf je huis schoon te maken of te fietsen in plaats van de auto te nemen.</p>

                <p>Weet je niet hoe je moet beginnen? Praat er dan met iemand over, bijvoorbeeld met een vriend die al veel beweegt of met je huisarts. Of neem contact op met de buurtsportcoach bij jou in de buurt. Die kun je bereiken via de gemeente.</p>

                <p>Aan het einde van de keuzehulp vind je meer informatie over het kiezen van een sport. </br>
                  En meer informatie over sporten als je een ziekte hebt die niet over gaat (chronische ziekte).
                </p>

                <img src=${process.env.PUBLIC_URL}/img/cvrm-stap-4_3_1.jpg alt="" />
              </div>
            `,
        },
        {
          cardTitle: 'Ik beweeg 3 keer per week',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/cvrm-stap-4_3_2-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Dat is heel goed! </br>
                Schrijf voor jezelf eens op hoeveel je beweegt. Tel het bij elkaar op. </br>
                Is dat meer dan 2,5 uur per week? Dan beweeg je genoeg. </br>
                Is dat minder dan 2,5 uur per week? Probeer dan meer te bewegen.
              </p>

              <p style="margin-bottom: 0;">Deze tips kunnen hierbij helpen:</p>
              <ul style="margin-top: 0;">
                <li>Probeer minder lang achter elkaar te zitten. Sta elk half uur even op om rond te lopen.</li>
                <li>Probeer de hele dag wat meer te bewegen. Door bijvoorbeeld in de tuin te werken, zelf je huis schoon te maken of te fietsen in plaats van de auto te nemen.</li>
                <li>Kies een activiteit of sport die je leuk vindt.</li>
                <li>Je kunt met andere mensen afspreken om samen te gaan bewegen.</li>
                <li>Hou het bewegen wat langer vol. Wandel of fiets bijvoorbeeld 10 minuten langer.</li>
              </ul>

              <p>Aan het einde van de keuzehulp vind je meer informatie over het kiezen van een sport. En meer informatie over sporten als je een ziekte hebt die niet over gaat (chronische ziekte).</p>
              <img src=${process.env.PUBLIC_URL}/img/cvrm-stap-4_3_2.jpg alt="" />
            </div>
            `,
        },
        {
          cardTitle: 'Ik beweeg vaker dan 3 keer per week',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/cvrm-stap-4_3_3-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Dat is heel goed! </br>
                Schrijf voor jezelf eens op hoeveel je beweegt. Tel het bij elkaar op. </br>
                Is dat meer dan 2,5 uur per week? Dan beweeg je genoeg. </br>
                Is dat minder dan 2,5 uur per week? Probeer dan meer te bewegen.
              </p>

              <p style="margin-bottom: 0;">Deze tips kunnen hierbij helpen:</p>
              <ul style="margin-top: 0;">
                <li>Probeer minder lang achter elkaar te zitten. Sta elk half uur even op om rond te lopen.</li>
                <li>Probeer de hele dag wat meer te bewegen. Door bijvoorbeeld in de tuin te werken, zelf je huis schoon te maken of te fietsen in plaats van de auto te nemen.</li>
                <li>Kies een activiteit of sport die je leuk vindt.</li>
                <li>Je kunt met andere mensen afspreken om samen te gaan bewegen.</li>
                <li>Hou het bewegen wat langer vol. Wandel of fiets bijvoorbeeld 10 minuten langer.</li>
              </ul>

              <p>Aan het einde van de keuzehulp vind je meer informatie over het kiezen van een sport. En meer informatie over sporten als je een ziekte hebt die niet over gaat (chronische ziekte).</p>
              <img src=${process.env.PUBLIC_URL}/img/cvrm-stap-4_3_3.jpg alt="" />
            </div>
            `,
        },
      ],
      button: 'Klaar met lezen, ga verder',
    },
    {
      path: '/stap-4/vraag-1',
      routeId: 'P14-020',
      nextRouteId: 'P14-021',
      type: 'question',
      title: 'Maak nu een plan',
      descriptionAlign: 'left',
      description: `<div>
            <p>Schrijf hier op wat je gaat doen aan bewegen. Denk aan:</p>

            <ul>
              <li>Hoe vaak per week ga je bewegen?</li>
              <li>Wat ga je doen?</li>
              <li>Hoe lang ga je bewegen?</li>
              <li>Ga je iemand vragen samen met je te bewegen?</li>
              <li>Wanneer ga je ermee beginnen?</li>
            </ul>
          </div>`,
      button: 'Volgende',
      questions: [
        {
          placeholder: 'Typ hier wat je gaat doen',
          title: 'Mijn plan om meer te bewegen',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-5',
      routeIndex: '5',
      routeId: 'P14-021',
      nextRouteId: 'P14-022',
      type: 'chapter',
      title: 'Gezond eten',
      subtitle: 'Stap 5',
      description: `<p>Gezond eten is belangrijk om gezond te worden en te blijven. Je leest eerst wat gezond eten is. Daarna zie je hoe eten en drinken invloed hebben op je gezondheid. En hoe je zelf gezonder kunt gaan eten.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/cvrm-stap-5.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-5/film-over-gezond-eten-en-drinken',
      routeId: 'P14-022',
      nextRouteId: 'P14-023',
      type: 'explanation',
      title: 'Film over gezond eten en drinken',
      align: 'left',
      titleAlign: 'center',
      description: `
          <div>
            <p>Gezond eten is belangrijk om gezond te worden en te blijven. Wil je weten hoe je gezonder kunt eten en drinken?</p>
          </div>
        `,
      button: 'Ga verder',
      videos: [
        {
          src: 'https://media.thuisarts.nl/zvm-gezond-eten.mp4',
          soundSrc: 'https://media.thuisarts.nl/zvm-gezond-eten.mp3',
          poster: 'https://media.thuisarts.nl/zvm-gezond-eten.jpg',
          videoSize: '30mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/zvm-gezond-eten.vtt',
              subtitleSize: '5kb',
            },
          ],
        },
      ],
    },
    {
      path: '/stap-5/tips-om-gezond-te-eten-en-drinken',
      routeId: 'P14-023',
      nextRouteId: 'P14-024',
      type: 'explanation',
      title: 'Tips om gezond te eten en drinken',
      align: 'left',
      titleAlign: 'center',
      description: `
          <div>
            <ul>
              <li>Kies vooral groente en fruit. En volkoren producten, zoals volkoren brood, volkoren pasta of zilvervliesrijst.</li>
              <li>Kies voor mager vlees en magere melkproducten. Zoals kip en magere yoghurt zonder smaakje.</li>
              <li>Drink water, thee en koffie zonder suiker. Drink geen dranken met suiker, zoals vruchtensap en frisdrank. Drink ook geen alcohol.</li>
            </ul>

            <p style="margin-bottom: 0;">Tips voor gezonde tussendoortjes:</p>
            <ul style="margin-top: 0;">
              <li>rauwe groenten, zoals tomaatjes, komkommer, radijs en wortel</li>
              <li>een handje ongezouten noten, zoals walnoten en amandelen</li>
              <li>een handje popcorn zonder suiker of zout</li>
            </ul>
          </div>
        `,
      button: 'Ga verder',
    },
    {
      path: '/stap-5/minder-suiker',
      routeId: 'P14-024',
      nextRouteId: 'P14-025',
      type: 'explanation',
      title: 'Minder suiker',
      align: 'left',
      titleAlign: 'center',
      description: `
          <div>
            <p>Suiker zit in eten en drinken. Bijvoorbeeld in frisdrank. </br>
              Te veel suiker eten of drinken is niet gezond. Je hebt dan een grotere kans dat je te zwaar wordt. En hierdoor heb je meer kans op een ziekte van hart en bloedvaten. Of op diabetes type 2.
            </p>

            <p>Wat kun je doen om minder suiker in je lichaam te krijgen?</p>
          </div>
        `,
      button: 'Ga verder',
      videos: [
        {
          src: 'https://media.thuisarts.nl/gezond-eten-met-minder-suiker.mp4',
          soundSrc: 'https://media.thuisarts.nl/gezond-eten-met-minder-suiker.mp3?',
          poster: 'https://media.thuisarts.nl/gezond-eten-met-minder-suiker.jpg',
          videoSize: '55,4mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/gezond-eten-met-minder-suiker.vtt',
              subtitleSize: '3,5kb',
            },
          ],
        },
      ],
    },
    {
      path: '/stap-5/vraag-1',
      routeId: 'P14-025',
      nextRouteId: 'P14-026',
      hideFromOverview: true,
      type: 'quizQuestion',
      subtitle: 'Je kunt 1 antwoord kiezen.',
      title: 'In al deze drankjes zit veel suiker. In welk drankje zit de meeste suiker?',
      quizAnswers: [
        'Sportdrank',
        'Sinaasappelsap',
        'Energiedrank',
        'Cola',
        'Appelsap',
        'Groene ijsthee',
      ],
      correctQuizAnswer: 'Sportdrank',
      explanation: `In sportdrank zit de meeste suiker. Appelsap en sinaasappelsap lijken misschien gezond. Maar ook hier zit heel veel suiker in. In appelsap zit zelfs meer suiker dan in cola.

          Drink je veel van deze dranken? Probeer er minder van te drinken. Kies vaker voor water. Of koffie of thee zonder suiker of melk.
          Als je veel frisfrank drinkt, heb je een grotere kans op diabetes type 2 of te zwaar zijn. En met diabetes of te zwaar zijn heb je weer meer kans op een ziekte van hart en bloedvaten.`,
      button: 'Ga verder',
    },
    {
      path: '/stap-5/minder-zout',
      routeId: 'P14-026',
      nextRouteId: 'P14-027',
      type: 'explanation',
      title: 'Minder zout',
      align: 'left',
      titleAlign: 'center',
      description: `
          <div>
            <p>Van te veel zout eten kun je een hoge bloeddruk krijgen. En dat geeft een groter risico op een ziekte van je hart en bloedvaten.</p>

            <p>Probeer dus minder zout te eten. Wil je weten hoe je dat doet?</p>
          </div>
        `,
      button: 'Ga verder',
      videos: [
        {
          src: 'https://media.thuisarts.nl/gezond-eten-minder-zout.mp4',
          soundSrc: 'https://media.thuisarts.nl/gezond-eten-minder-zout.mp3',
          poster: 'https://media.thuisarts.nl/gezond-eten-minder-zout.jpg',
          videoSize: '',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/gezond-eten-minder-zout.vtt',
              subtitleSize: '5kb',
            },
          ],
        },
      ],
    },
    {
      path: '/stap-5/vraag-2',
      routeId: 'P14-027',
      nextRouteId: 'P14-028',
      hideFromOverview: true,
      type: 'quizQuestion',
      subtitle: 'Je kunt 1 antwoord kiezen.',
      title: 'Welk zout is het gezondst?',
      quizAnswers: [
        'Keukenzout',
        'Himalaya-zout',
        'Zeezout',
        'Keltisch zeezout',
        'Het maakt niet uit',
      ],
      correctQuizAnswer: 'Het maakt niet uit',
      explanation: `In zeezout, Himalaya-zout en Keltisch zeezout zitten wel wat andere stoffen die gezond kunnen zijn. Maar dat is zo weinig dat je er niets aan hebt.
          Het is vooral belangrijk dat je niet te veel zout eet. In eten zit al genoeg zout. Bijvoorbeeld in brood, groenten, vlees en vis en aardappelen. Het is niet nodig daar extra zout bij te doen.`,
      button: 'Ga verder',
    },
    {
      path: '/stap-5/andere-producten',
      routeId: 'P14-028',
      nextRouteId: 'P14-029',
      type: 'popupCards',
      title: 'Andere producten',
      align: 'left',
      description: `
        <div>
          <p>Naast suiker en zout zijn er ook andere producten die je beter niet te veel kunt nemen. En producten die je risico op een ziekte van hart en bloedvaten niet kleiner maken.</p>
          <p>Klik op het product waarover je meer wilt weten:</p>
        </div>
      `,
      cards: [
        {
          cardTitle: 'Alcohol',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/cvrm-stap-5_7_1-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Het beste is om geen alcohol te drinken. Wil je toch wat drinken? Drink dan niet meer dan 1 of een paar glazen per week. En niet iedere dag.</p>

              <p>Alcohol drinken geeft je een groter risico op een ziekte van hart en bloedvaten. Hoe meer alcohol je drinkt, hoe groter het risico wordt.</p>
              <img src=${process.env.PUBLIC_URL}/img/cvrm-stap-5_7_1.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Drop, zoethout-thee en sterrenmix-thee',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/cvrm-stap-5_7_2-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Van drop, zoethout-thee en sterrenmix-thee kan je bloeddruk hoger worden.</p>

              <p>Er zit namelijk een stofje in dat ervoor zorgt dat je lichaam vocht vasthoudt. Dit stofje heet glycyrrhizine. Hierdoor gaat je bloeddruk omhoog.</p>

              <p>Dat gebeurt alleen als je er te veel van neemt. Een paar dropjes of 1 kopje zoethout-thee per dag is niet erg.</p>

              <p>Eet je vaak drop? Of drink je veel zoethout-thee of sterrenmix-thee? Probeer hier minder van te nemen.</p>
              <img src=${process.env.PUBLIC_URL}/img/cvrm-stap-5_7_2.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Koffie',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/cvrm-stap-5_7_3-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>In koffie zit een stof die cholesterol in je bloed hoger maakt. Deze stof heet cafestol. Drink je graag koffie? Neem dan altijd filterkoffie. Daar zit het minste cafestol in.</p>

              <p>Cholesterol is een soort vet. Je lichaam maakt cholesterol in de lever. Ook komt er cholesterol in je lichaam via je voeding.</br>
                Je hebt cholesterol nodig om cellen, hormonen en gal te maken. Maar te veel cholesterol is slecht voor je bloedvaten.
              </p>
              <img src=${process.env.PUBLIC_URL}/img/cvrm-stap-5_7_3.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Visolie',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/cvrm-stap-5_7_4-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Sommige mensen denken dat je met pillen met visolie minder cholesterol in je lichaam krijgt.</p>

              <p>Sommige pillen met visolie kunnen misschien zorgen voor een iets lager cholesterol. Dit is niet zeker.</p>

              <p>Er is onderzoek gedaan om te weten of visolie de kans op een ziekte van hart en bloedvaten kleiner maakt. Waarschijnlijk is dit niet zo.</p>
              <img src=${process.env.PUBLIC_URL}/img/cvrm-stap-5_7_4.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Rode-gist-rijst',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/cvrm-stap-5_7_5-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Je kunt beter geen rode-gist-rijst pillen slikken.</p>

              <p>We weten niet of deze pillen de kans op een ziekte van hart en bloedvaten kleiner maken. We weten ook niet wat de pillen met je lichaam doen als je ze een lange tijd slikt. Ook kunnen er gifstoffen in de pillen zitten. En ze kunnen bijwerkingen geven.</p>

              <p>De pillen kunnen cholesterol in je lichaam wel iets lager maken. Maar gezond eten en gezond bewegen zijn belangrijker om je risico op een ziekte van hart en bloedvaten kleiner te maken.</p>
              <img src=${process.env.PUBLIC_URL}/img/cvrm-stap-5_7_5.jpg alt="" />
            </div>
          `,
        },
      ],
      button: 'Klaar met lezen, ga verder',
    },
    {
      path: '/stap-5/vraag-3',
      routeId: 'P14-029',
      nextRouteId: 'P14-030',
      type: 'question',
      title: 'Maak nu een plan om gezonder te gaan eten',
      descriptionAlign: 'left',
      description: `<div>
        <p style="margin-bottom: 0;">Schrijf hier op wat je gaat doen om gezonder te eten:</p>

        <ul style="margin-top: 0;">
          <li>Wat ga je precies doen? Bijvoorbeeld nog maar 1 keer per dag iets tussendoor eten. Of voortaan een banaan meenemen zodat je geen ongezonde snacks gaat eten.</li>
          <li>Wanneer ga je beginnen?</li>
          <li>Denk je dat je het zelf niet kunt? Maak dan een afspraak bij een diëtist. Die kan je advies geven en helpen om gezonder te eten of af te vallen. Zet het in je plan als je dat gaat doen.</li>
        </ul>
      </div>`,
      button: 'Volgende',
      questions: [
        {
          placeholder: 'Typ hier wat je gaat doen',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-6',
      routeIndex: '6',
      routeId: 'P14-030',
      nextRouteId: 'P14-031',
      type: 'chapter',
      title: 'Minder stress',
      subtitle: 'Stap 6',
      description: `<p>Als je lang veel stress hebt, is je risico op een ziekte van hart en bloedvaten groter. Hoe zorg je voor minder stress?</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/cvrm-stap-6.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-6/minder-stress',
      routeId: 'P14-031',
      nextRouteId: 'P14-032',
      type: 'explanation',
      title: 'Minder stress',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p style="margin-bottom: 0;">Veel stress geeft meer kans op een ziekte van hart en bloedvaten. Waarschijnlijk komt dit doordat mensen door stress ongezonder gaan leven. Ze gaan bijvoorbeeld minder bewegen of meer en ongezond eten.</br> Bijvoorbeeld:</p>
          <ul style="margin-top: 0;">
            <li>niet gezond eten</li>
            <li>weinig bewegen</li>
            <li>vaker en meer roken</li>
          </ul>

          <p>Wil je tips om minder stress te hebben?</p>
        </div>
      `,
      button: 'Ga verder',
      videos: [
        {
          title: 'Bekijk de film',
          src: 'https://media.thuisarts.nl/zvm-minder-stress.mp4',
          soundSrc: 'https://media.thuisarts.nl/zvm-minder-stress.mp3',
          poster: 'https://media.thuisarts.nl/zvm-minder-stress.jpg',
          videoSize: '25mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/zvm-minder-stress.vtt',
              subtitleSize: '3kb',
            },
          ],
        },
      ],
    },
    {
      path: '/stap-7',
      routeIndex: '7',
      routeId: 'P14-032',
      nextRouteId: 'P14-033',
      type: 'chapter',
      title: 'Nachtwerk',
      subtitle: 'Stap 7',
      description: `<p>Werk je vaak in de nacht? Dan heb je een grotere kans op een ziekte van hart en bloedvaten.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/cvrm-stap-7.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-7/gezond-werken-in-de-nacht',
      routeId: 'P14-033',
      nextRouteId: 'P14-034',
      type: 'explanation',
      title: 'Gezond werken in de nacht',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Werken in de nacht verstoort het dag-nacht-ritme van je lichaam. Dit ritme is belangrijk voor bijvoorbeeld je hart, je bloeddruk en hormonen in je bloed.</p>

          <p style="margin-bottom: 0;">Als je veel in de nacht werkt, heb je een grotere kans op:</p>
          <ul style="margin-top: 0;">
            <li>ziektes van hart en bloedvaten</li>
            <li>diabetes (suikerziekte)</li>
            <li>te zwaar zijn</li>
            <li>te hoog cholesterol</li>
            <li>hoge bloeddruk</li>
          </ul>

          <p>Deze kans is nog niet zo groot als je maar een paar jaar in de nacht werkt. Je kans wordt groter als je het veel jaren achter elkaar doet.</p>

          <p>Wil je meer weten over gezond werken in de nacht?</p>
        </div>
      `,
      button: 'Ga verder',
      videos: [
        {
          src: 'https://media.thuisarts.nl/werken-in-de-nacht.mp4',
          soundSrc: 'https://media.thuisarts.nl/werken-in-de-nacht.mp3',
          poster: 'https://media.thuisarts.nl/werken-in-de-nacht.jpg',
          videoSize: '71 kb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/werken-in-de-nacht.vtt',
              subtitleSize: '3kb',
            },
          ],
        },
      ],
    },
    {
      path: '/stap-8',
      routeIndex: '8',
      routeId: 'P14-034',
      nextRouteId: 'P14-035',
      type: 'chapter',
      title: 'Volhouden',
      subtitle: 'Stap 8',
      description: `<p>Gezonder leven kan best moeilijk zijn. Je moet misschien nieuwe gewoontes aanleren. Hoe kun je gezond leven volhouden?</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/cvrm-stap-8.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-8/gezond-leven-volhouden',
      routeId: 'P14-035',
      nextRouteId: 'P14-036',
      type: 'explanation',
      title: 'Gezond leven volhouden',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Het kan moeilijk zijn om alle dingen die je met jezelf hebt afgesproken te gaan doen.</p>

          <p>Vaak lukt het een tijd wel om bijvoorbeeld meer te bewegen of gezonder te eten. Maar dan is er weer een feestje. Of iemand biedt je een sigaret aan. En dan lukt het ineens niet meer om het vol te houden.</p>

          <p>Hoe kun je gezond leven volhouden?</p>
        </div>
      `,
      button: 'Ga verder',
      videos: [
        {
          title: 'Volhouden',
          src: 'https://media.thuisarts.nl/zvm-volhouden.mp4',
          soundSrc: 'https://media.thuisarts.nl/zvm-volhouden.mp3',
          poster: 'https://media.thuisarts.nl/zvm-volhouden.jpg',
          videoSize: '24mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/zvm-volhouden.vtt',
              subtitleSize: '3kb',
            },
          ],
        },
      ],
    },
    {
      path: '/stap-8/meer-lezen-over-gezond-leven',
      routeId: 'P14-036',
      nextRouteId: 'P14-037',
      type: 'explanation',
      title: 'Meer lezen over gezond leven',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Klik op de links voor meer informatie over:</p>

          <ul>
            <li><a href="https://www.thuisarts.nl/hoge-bloeddruk/ik-heb-hoge-bloeddruk" target="_blank">Hoge bloeddruk</a></li>
            <li><a href="https://www.thuisarts.nl/cholesterol/ik-heb-hoog-cholesterol" target="_blank">Cholesterol</a></li>
            <li><a href="https://www.thuisarts.nl/stoppen-met-roken/ik-wil-misschien-stoppen-met-roken-0" target="_blank">Stoppen met roken</a></li>
            <li><a href="https://www.thuisarts.nl/risico-hart-en-vaatziekten-verlagen/ik-ga-medicijnen-gebruiken-om-mijn-risico-op-hart-en" target="_blank">Medicijnen bij een ziekte van hart en bloedvaten</a></li>
            <li><a href="https://www.sportkeuzewijzer.nl/" target="blank">Een sport kiezen die bij je past</a></li>
            <li><a href="https://www.sportzorg.nl/sport-bewegen/chronische-aandoeningen" target="_blank">Meer bewegen bij een ziekte die niet over gaat (chronische ziekte)</a></li>
            <li><a href="https://www.thuisarts.nl/stress/ik-wil-beter-omgaan-met-stress" target="_blank">Beter omgaan met stress</a></li>
            <li><a href="https://www.thuisarts.nl/hulp-bij-psychische-klachten-bij-volwassenen/ik-heb-psychische-klachten-hoe-ga-ik-daar-mee-om" target="_blank">Omgaan met psychische klachten</a></li>
            <li><a href="https://www.thuisarts.nl/nachtdiensten-en-gezondheid/ik-werk-vaak-s-nachts-hoe-blijf-ik-gezond" target="_blank">Gezond werken in de nacht</a></li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/print-overview',
      routeIndex: '9',
      routeId: 'P14-037',
      nextRouteId: 'end',
      type: 'end',
      header: {
        title: 'Je antwoorden bij deze keuzehulp',
        description: `
          <div>
            <p>Je bent nu klaar met de keuzehulp.</p>
            <p>Heb je nog vragen? Kijk dan op Thuisarts.nl of stel ze aan je huisarts.</p>
          </div>
        `,
      },
    },
  ],
}

export default cvrm
